// extracted by css-extract-rspack-plugin
export default {"congrats":"congrats-huCIO3 text-xl-medium"};